import { render } from "./AddApropos.vue?vue&type=template&id=0a02103a&ts=true"
import script from "./AddApropos.vue?vue&type=script&lang=ts"
export * from "./AddApropos.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__